<template>
  <div class="row no-gutters"
       v-if="mode != 'technic' || title">
    <div class="col-auto">
      <div class="pr-2">
        <component :is="svgComponent"/>
      </div>
    </div>
    <div class="col">
      <div @click="startEditing"
           v-click-outside="clickOutside">
        <a v-if="!editMode"
           class="text-body"
           :class="{ 'cellEditable pointer': editable }">
          <span v-if="title">{{ title }}</span>
          <span v-else class="text-muted">{{ $t('not_selected') }}</span>
        </a>
        <select v-model="pivot[attr]"
                v-if="editMode"
                ref="selectEl"
                @input="changeParam"
                class="form-control mw-auto sm"
                :disabled="!editable">
          <option v-for="obj in options"
                  :key="`option-doc-${obj.id}`"
                  :value="obj.id">
            {{ obj.full_name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup>
import DoctorSvg from '@/assets/svg-vue/services/service_doctor.svg'
import TechnicSvg from '@/assets/svg-vue/services/hammer.svg'
import {computed, inject, nextTick, ref} from "vue"
import {useStore} from "vuex"

const props = defineProps({
  service: Object,
  readonly: Boolean,
  mode: {
    type: String,
    default: 'doctor'
  }
})

const store = useStore()
const versionCount = inject('versionCount')

const editMode = ref(false)
const justOpened = ref(false)
const selectEl = ref(null)

const doctors = computed(() => store.state.auth.doctors)
const technics = computed(() => props.service.technics || [])
const pivot = computed(() => props.service?.pivot)
const attr = computed(() => `${props.mode}_id`)
const teeth = computed(() => store.state.patient?.visit?.record_teeth || [])

const doctor = computed(() => doctors.value.find(d => d.id === pivot.value.doctor_id))
const technic = computed(() => technics.value.find(d => d.id === pivot.value.technic_id))

const editable = computed(() => !props.readonly && (options.value || []).length)

const svgComponent = computed(() => {
  if(props.mode === 'technic') return TechnicSvg
  return DoctorSvg
})

const options = computed(() => {
  const arr = props.mode === 'technic' ? technics.value : doctors.value
  return arr.map(a => ({
    id: a.id,
    full_name: a.full_name,
  }))
})

const title = computed(() => {
  if(props.mode === 'technic') return technic.value?.full_name
  return doctor.value?.full_name
})

const startEditing = () => {
  if(!editable.value) return
  editMode.value = true
  justOpened.value = true
  setTimeout(() => {
    justOpened.value = false
  }, 50)
  nextTick(() => {
    selectEl.value?.focus()
    selectEl.value?.dispatchEvent(new KeyboardEvent('keydown', { key: 'ArrowDown' }))
  })
}

const clickOutside = () => {
  if(justOpened.value) return
  editMode.value = false
}

const changeParam = async () => {
  await nextTick()
  teeth.value.forEach((tooth) => {
    tooth.services.forEach(service => {
      if(service.id === props.service.id) {
        service.pivot[attr.value] = pivot.value[attr.value]
      }
    })
  })
  clickOutside()
  versionCount.value++
}
</script>
